import { Box, styled } from '@mui/material';

const PREFIX = 'TSMED-DataErrorsCountTile';
export const dataErrorsCountTileClasses = {
  root: `${PREFIX}-root`,
  largeCaption: `${PREFIX}-largeCaption`,
  smallCaption: `${PREFIX}-smallCaption`,
  disabled: `${PREFIX}-disabled`,
} as const;

type RootProps = {
  compact?: boolean;
};

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root,
  shouldForwardProp: prop => prop !== 'compact',
})<RootProps>(
  ({ theme: { palette, spacing, utils, breakpoints }, compact }) => ({
    [`&.${dataErrorsCountTileClasses.root}`]: {
      display: 'inline-flex',
      border: `1px solid ${palette.grey[700]}`,
      borderRadius: 10,
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      verticalAlign: 'top',
      fontWeight: compact ? 500 : 600,
      color: palette.orange[500],
      padding: compact ? spacing(1) : spacing(3, 6),
      width: '100%',
      height: '100%',

      [breakpoints.down('md')]: {
        padding: spacing(1, 3),
      },
    },

    [`& .${dataErrorsCountTileClasses.largeCaption}`]: {
      fontSize: utils.clamp(compact ? 18 : 20, compact ? 20 : 36, 'md-4k'),
      marginRight: utils.clamp(10, 17),
    },

    [`& .${dataErrorsCountTileClasses.smallCaption}`]: {
      fontSize: utils.clamp(compact ? 14 : 16, compact ? 20 : 26, 'md-4k'),
    },

    [`&.${dataErrorsCountTileClasses.disabled}`]: {
      color: palette.grey[700],
    },
  }),
);

interface Props {
  dataErrorsCount: number;
  backendNetworkError: string;
  compact?: boolean;
}

export const DataErrorsCountTile = ({
  dataErrorsCount,
  backendNetworkError,
  compact = false,
}: Props) => (
  <Root
    className={`${dataErrorsCountTileClasses.root} ${
      backendNetworkError ? dataErrorsCountTileClasses.disabled : ''
    }`}
    compact={compact}
  >
    <span className={dataErrorsCountTileClasses.largeCaption}>
      {dataErrorsCount}
    </span>
    <span className={dataErrorsCountTileClasses.smallCaption}>
      {`WARNING${dataErrorsCount !== 1 ? 'S' : ''}`}
    </span>
  </Root>
);
